"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zUpsertPartOnUseRequest = exports.zListPartsQuery = exports.zUpdatePartRequest = exports.zCreatePartRequest = void 0;
const zod_1 = require("zod");
const query_params_js_1 = require("./query-params.js");
const money_js_1 = require("./money.js");
const editableFields = {
    description: zod_1.z.string().trim().min(1),
    category: zod_1.z.string().trim().min(1).nullable().optional(),
    currentListPrice: money_js_1.zMoney.nullable().optional(),
    defaultTaxable: zod_1.z.boolean().default(true),
};
exports.zCreatePartRequest = zod_1.z.object({
    // partNumber is intentionally the only field NOT re-editable after
    // creation (see zUpdatePartRequest) — changing it would change the
    // GENERATED `part_number_normalized` column that the whole
    // auto-create-on-use upsert model keys on.
    partNumber: zod_1.z.string().trim().min(1),
    ...editableFields,
});
exports.zUpdatePartRequest = zod_1.z.object(editableFields).partial();
exports.zListPartsQuery = zod_1.z.object({
    // Matches part number or description (both trigram-indexed).
    search: zod_1.z.string().trim().min(1).optional(),
    category: zod_1.z.string().trim().min(1).optional(),
    includeInactive: query_params_js_1.zBooleanQueryParam.default(false),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(25),
    offset: zod_1.z.coerce.number().int().min(0).default(0),
});
/**
 * What a work-order line calls when a part is typed/selected into a
 * line — see PartsService.upsertOnUse(). Deliberately NOT the same shape
 * as create: no `defaultTaxable` override here, because upserting an
 * EXISTING part must never silently change its catalog price or
 * taxability out from under other lines that reference it — see that
 * method's doc comment.
 */
exports.zUpsertPartOnUseRequest = zod_1.z.object({
    partNumber: zod_1.z.string().trim().min(1),
    description: zod_1.z.string().trim().min(1),
    currentListPrice: money_js_1.zMoney.nullable().optional(),
});
//# sourceMappingURL=parts.js.map